import React from 'react';
import { motion } from 'framer-motion';
import { Apple } from 'lucide-react';
import { Sparkles, FloatingParticles, WaterReflection } from './Sparkles';
export function CTASection() {
  return <section className="py-32 px-6 bg-pond-dark relative overflow-hidden" data-id="element-42">
      {/* Stillness effects */}
      <Sparkles count={8} className="opacity-50" data-id="element-43" />
      <FloatingParticles count={6} data-id="element-44" />
      <WaterReflection className="top-1/4" data-id="element-45" />
      <WaterReflection className="bottom-1/3" data-id="element-46" />

      {/* Soft ambient glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-47">
        <motion.div className="absolute bottom-0 left-1/4 w-[600px] h-[400px] bg-pond-blue/10 rounded-full blur-[150px]" animate={{
        opacity: [0.4, 0.6, 0.4]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-48" />
        <motion.div className="absolute top-0 right-1/4 w-[400px] h-[300px] bg-pond-lavender/8 rounded-full blur-[120px]" animate={{
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 3
      }} data-id="element-49" />
        {/* Mint accent */}
        <motion.div className="absolute bottom-1/4 right-1/3 w-[300px] h-[300px] bg-emerald-500/5 rounded-full blur-[100px]" animate={{
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 5
      }} data-id="element-50" />
      </div>

      <motion.div className="relative z-10 max-w-4xl mx-auto text-center" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} data-id="element-51">
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-serif text-pond-cream mb-8 leading-tight" data-id="element-52">
          Begin Your
          <br data-id="element-53" />
          <span className="gradient-text" data-id="element-54">Practice</span>
        </h2>

        <p className="text-xl md:text-2xl text-pond-cream-muted mb-12 font-light" data-id="element-55">
          Pond — a calmer way to use your phone.
        </p>

        <motion.a href="https://go.pixo.co/pond_landing" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-pond-blue to-pond-lavender text-pond-dark text-lg font-medium rounded-full overflow-hidden transition-all hover:shadow-xl hover:shadow-pond-blue/20" whileHover={{
        y: -3
      }} whileTap={{
        scale: 0.98
      }} data-id="element-56">
          <Apple size={24} data-id="element-57" />
          <span data-id="element-58">Download on the App Store</span>
        </motion.a>

        <p className="mt-8 text-sm text-pond-cream-muted/60" data-id="element-59">
          Free to download • iOS 16+
        </p>
      </motion.div>
    </section>;
}